import {
  checkboxClasses,
  Components,
  formControlLabelClasses,
  Theme,
} from '@mui/material';

function CheckboxIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 20 20"
      width="20"
      height="20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="5"
        fill="var(--checkbox-background)"
        stroke="var(--checkbox-border)"
        strokeWidth="2"
      />
      <path
        d="M4.85378 10.7317L4.07292 10.107L2.82353 11.6688L3.60439 12.2934L4.85378 10.7317ZM8.74203 15.1229L8.11733 15.9038C8.33909 16.0812 8.62581 16.156 8.90595 16.1094C9.18609 16.0629 9.43323 15.8994 9.58569 15.6598L8.74203 15.1229ZM15.9038 5.73134L16.4407 4.88768L14.7534 3.81393L14.2165 4.65759L15.9038 5.73134ZM3.60439 12.2934L8.11733 15.9038L9.36672 14.3421L4.85378 10.7317L3.60439 12.2934ZM9.58569 15.6598L15.9038 5.73134L14.2165 4.65759L7.89837 14.5861L9.58569 15.6598Z"
        fill="var(--checkbox-checked)"
      />
    </svg>
  );
}

function CheckboxIndeterminateIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 20 20"
      width="20"
      height="20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="5"
        fill="var(--checkbox-background)"
        stroke="var(--checkbox-border)"
        strokeWidth="2"
      />
      <path
        d="M6 10.5H14"
        stroke="var(--checkbox-checked)"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
}

export const getMuiCheckbox = (theme: Theme): Components['MuiCheckbox'] => ({
  defaultProps: {
    icon: <CheckboxIcon />,
    checkedIcon: <CheckboxIcon />,
    indeterminateIcon: <CheckboxIndeterminateIcon />,
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
      fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
      boxShadow: 'none',
      padding: 0,

      '--checkbox-background': theme.palette.background.paper,
      '--checkbox-border': theme.palette.grey[600],
      '--checkbox-checked': 'unset',

      '&:hover': {
        '--checkbox-background': theme.palette.grey[100],
      },

      [`&.${checkboxClasses.checked}`]: {
        '--checkbox-background': theme.palette.primary.main,
        '--checkbox-border': 'unset',
        '--checkbox-checked': theme.palette.background.paper,

        '&:hover': {
          '--checkbox-background': theme.palette.primary.dark,
        },
      },

      [`&.${checkboxClasses.disabled}`]: {
        '--checkbox-background': theme.palette.grey[100],
        '--checkbox-border': theme.palette.grey[100],
        '--checkbox-checked': 'unset',

        [`&.${checkboxClasses.checked}`]: {
          '--checkbox-checked': theme.palette.grey[400],
        },
      },
    },
  },

  variants: [
    {
      props: { size: 'medium' },
      style: {
        width: 24,
        height: 24,

        [`+.${formControlLabelClasses.label}`]: {
          margin: theme.spacing(0, 0, 0, 3),
          fontWeight: 400,
          fontSize: 16,
          lineHeight: 1.5,
        },
      },
    },
    {
      props: { size: 'small' },
      style: {
        width: 18,
        height: 18,

        [`+.${formControlLabelClasses.label}`]: {
          margin: theme.spacing(0, 0, 0, 3),
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 1.43,
          letterSpacing: '0.01em',
        },
      },
    },
  ],
});
